import { useEffect, useState } from "preact/hooks"
import { modalColor } from "src/161759/utils"
import { Modal, ModalWrapper } from "src/utils/fw"

const full = {width: "100%"}
const inputStyle = {
    ...full,
    display: "block",
    background: "white",
    border: 0,
    padding: "15px 10px",
    borderRadius: "3px",
    marginTop: "8px",
    color: "black"
}

export const dismiss = {
    padding: "6px 7px", 
    textAlign: "center", 
    lineHeight: ".8",
    fontSize: "21px",
    borderRadius: "100%",
    color: "white",
    width: undefined,
    height: undefined,
    right: "5px",
    top: "5px"
}

export default ({roomName = null, displayOnly = false, open = false, onClose}) => {


    const [isDisplayed, setIsDisplayed] = useState(displayOnly ? window.localStorage.getItem(roomName || "AIForm") === "true" : false)
    const [load, setLoad] = useState({
        loading: false,
        msg: "",
        type: "waiting"
    })

    useEffect(() => {
        console.log(isDisplayed && displayOnly)
        if (isDisplayed && displayOnly) {
            window.localStorage.setItem(roomName || "AIForm", true)
        }
    }, [isDisplayed])

    if (load.type === "done") {
        setTimeout(() => {
            setLoad(it => {
                return {...it, type: "hide"}
            })
            if (displayOnly) setIsDisplayed(true)
        }, 1000)
    }

    if (!open || isDisplayed || load.type === "hide") return <></>

    return <Modal dismissHTML="X" dismissStyle={dismiss} dismiss={() => {
        if (onClose) onClose()
        if (displayOnly) setIsDisplayed(true)
    }}>
        <ModalForm close={() => {
            onClose()
            setIsDisplayed(true)
        }}/>
    </Modal>
}

export const ModalForm = ({close}) => {
    const [option, setOption] = useState(null)
    const [other, setOther] = useState("")
    const [load, setLoad] = useState({
        loading: false,
        msg: "",
        type: "waiting"
    })

    const submitHdlr = (ev) => {
        ev.preventDefault();
        const eventId = 161759
        const registrantId = window.dataLayer[0]["Registrant ID"]
        const data = { eventId, registrantId, other: option === "Other" ? other : undefined, option }

        setLoad(it => {
            return {...it, loading: true}
        })

        fetch("https://popupfunctions.tkevents.io/create/" + eventId, {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json"
            }
        }).then(() => {
            setLoad(it => {
                return {...it, loading: false, type: "done", msg: "Thanks for your submission!"}
            })
            if (close) setTimeout(() => {close()}, 1000)
        }).catch(() => {
            setLoad(it => {
                return {...it, loading: false, type: "error", msg: "try again"}
            })
        })
    }

    return <ModalWrapper wrapperStyle={{backgroundColor: modalColor, color: "white", maxWidth: "433px", fontSize: "medium"}}>
    <p>
        Which topic would you like to see researched next in the AI Insights series?
    </p>
    {load.type !== "done" && 
        <form onSubmit={submitHdlr}>
            <div style={{textAlign: "left", display: "flex", flexDirection: "column", alignItems: "center"}}>
                <div style={{...full, display: "flex", justifyContent: "center"}}>
                    <div style={{...full, marginRight: "20px"}}>
                        <div onChange={(ev) => {
                            console.log(ev.target.value)
                            setOption(ev.target.value)
                        }}>
                            <input type="radio" id="aigov" name="ai_insight" value="AI governance" />
                            <label for="aigov">AI governance</label><br/>
                            <input type="radio" id="eoai" name="ai_insight" value="The ethics of AI" />
                            <label for="eoai">The ethics of AI</label><br/>
                            <input type="radio" id="impact" name="ai_insight" value="AI and its impact on security behaviours" />
                            <label for="impact">AI and its impact on security behaviours</label><br/>
                            <input type="radio" id="supply" name="ai_insight" value="AI in the supply chain" />
                            <label for="supply">AI in the supply chain</label><br/>
                            <input type="radio" id="other" name="ai_insight" value="Other" />
                            <label for="other">Other</label>
                        </div>
                    
                    { option === "Other" && <div style={full}>
                            <input disabled={load.loading} style={inputStyle} value={other} required name="other" type="text" placeholder="Other" onChange={ev =>{setOther(ev.target.value)}}/>
                        </div>
                    }
                    </div>
                </div>
                <div style={{marginTop: "20px"}}>
                    <button type="submit" style={{
                            padding: "15px 30px",
                            borderRadius: "4px",
                            border: 0,
                            fontWeight: "bold",
                            color: "white",
                            background: "#187bff",
                            cursor: "pointer"
                    }}>
                        Submit
                    </button>
                </div>
            </div>
        </form>
    }
    {
        load.type === "done" && <p>{load.msg}</p>
    }
</ModalWrapper>
}